import PlacesAutocomplete from "stimulus-places-autocomplete"

// Connects to data-controller="places"
export default class extends PlacesAutocomplete {
  static targets = ["streetAndStreetNumber"];

  initialize() {
    super.initialize();
    this.initAutocomplete = this.initAutocomplete.bind(this);
    this.restoreInput = this.restoreInput.bind(this);
  }

  connect() {
    this.countryValue = ["ca"];
    document.addEventListener("google-maps-callback", this.initAutocomplete);
    document.addEventListener("google-maps-auth-failure", this.restoreInput);
    super.connect();
  }

  disconnect() {
    document.removeEventListener("google-maps-callback", this.initAutocomplete);
    document.removeEventListener("google-maps-auth-failure", this.restoreInput);
    super.disconnect();
  }

  get autocompleteInput() {
    return this.hasStreetAndStreetNumberTarget ? this.streetAndStreetNumberTarget : this.addressTarget;
  }

  initAutocomplete() {
    if (window.googleMapsAuthFailed || this.autocomplete || !window.google?.maps?.places) return;

    const { disabled, placeholder } = this.autocompleteInput;
    this.inputState = { disabled, placeholder };
    this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput, this.autocompleteOptions);
    this.autocomplete.addListener('place_changed', this.placeChanged);
  }

  restoreInput() {
    if (!this.inputState) return;

    const input = this.autocompleteInput;

    Object.assign(input, this.inputState);
    input.classList.remove("gm-err-autocomplete");
    input.style.removeProperty("background-image");
  }

  setAddressComponents(address) {
    super.setAddressComponents(address);

    if (this.hasStreetAndStreetNumberTarget) {
      this.streetAndStreetNumberTarget.value = [(address.street_number || ''), (address.route || '')].join(" ");
    }
    if (this.hasCountryTarget) {
      this.countryTarget.value = this.countryValue[0].toUpperCase();
    }
  }
}
